import { MotionSource } from './MotionSource';
import { DEFAULT_BPM, DEFAULT_VIDEO_DURATION } from '../data/Config';
import { MotionSourceData } from '../data/FlyerData';

export class MuteMotionSource extends MotionSource {
  soundtrackDuration: number = 0; // 0 = undefined
  protected _isCustom: boolean = false;
  private _maxDuration: number = DEFAULT_VIDEO_DURATION;

  private _endTimer: number = 0;

  private _lastCurrentTime: number = 0;
  private _lastTimeStarted: number = 0;

  constructor() {
    super();

    this.bpm = DEFAULT_BPM;
    this._lastTimeStarted = Date.now();
  }

  populateWithData(data: MotionSourceData) {
    this._maxDuration = data.maxDuration;
    this.bpm = data.bpm;
  }

  asData(): MotionSourceData {
    const { bpm, type, maxDuration } = this;
    return {
      bpm,
      type,
      maxDuration
    };
  }

  // Motion Source

  isCustom(): boolean {
    return this._isCustom || this._bpm !== DEFAULT_BPM;
  }

  reset() {
    this._lastTimeStarted = Date.now();
    this.endCallback = null;
  }

  resetPoints() {
    this._isCustom = false;
  }

  play() {
    // animate
    clearTimeout(this._endTimer);
    this._lastTimeStarted = Date.now();
    this.isPlaying = true;
    this._endTimer = window.setTimeout(this.didEnd, this.getDuration());
  }

  resume() {
    if (this.isPlaying) {
      return;
    }
    // resume
    this._lastTimeStarted = Date.now() - this._lastCurrentTime;
    this.isPlaying = true;
    this._endTimer = window.setTimeout(
      this.didEnd,
      this.getDuration() - this._lastCurrentTime
    );
  }

  pause() {
    // pause
    clearTimeout(this._endTimer);
    this._lastCurrentTime = this.getCurrentTime();
    this.isPlaying = false;
  }

  jumpTo(millis: number) {
    clearTimeout(this._endTimer);
    this._lastTimeStarted = Date.now() - millis;
    this.isPlaying = true;
    this._endTimer = window.setTimeout(
      this.didEnd,
      this.getDuration() - millis
    );
  }

  restart() {
    clearTimeout(this._endTimer);
    this._lastTimeStarted = Date.now();
    this._endTimer = window.setTimeout(this.didEnd, this.getDuration());
  }

  getLoopDuration(): number {
    return (60 / this.bpm) * 1000;
  }

  getDuration(): number {
    return (
      this.soundtrackDuration ||
      Math.min(this.getLoopDuration() * this.loopsCount, this.maxDuration)
    );
  }

  getCurrentTime(): number {
    if (!this.isPlaying) {
      return this._lastCurrentTime;
    }
    const offset = Date.now() - this._lastTimeStarted;
    return Math.min(this.getDuration(), offset);
  }

  getLevelAt(position: number, option: any = undefined): number {
    return 0;
  }

  getLevel(option: any = undefined): number {
    return this.getLevelAt(this.getCurrentTime());
  }

  // Own

  didEnd = () => {
    this.play();
    if (this.endCallback) {
      this.endCallback();
      this.endCallback = null;
    }
    this.emit('loop');
  };

  get bpm(): number {
    return this._bpm;
  }
  set bpm(v: number) {
    this._bpm = v;
    this.updateLoopsCount();
  }

  get maxDuration(): number {
    return this._maxDuration;
  }
  set maxDuration(v: number) {
    this._maxDuration = v;
    this.updateLoopsCount();
    if (this.isPlaying) {
      this.restart();
    } else {
      this._lastCurrentTime = 0;
    }
  }

  private updateLoopsCount() {
    const loopDuration = this.getLoopDuration();
    this.loopsCount = Math.max(1, Math.floor(this._maxDuration / loopDuration));
  }
}



// WEBPACK FOOTER //
// ./src/motion/MuteMotionSource.ts